import React from "react";
import { Trans } from "react-i18next";

import { Callout, FormGroup, NumericInput } from "@blueprintjs/core";
import {
  authenticatedGetFetch,
  authenticatedPostFetch,
} from "../../../utils/AuthenticatedFetch";

export default function Delays(props) {
  const [delays, setDelays] = React.useState([]);

  React.useEffect(() => {
    authenticatedGetFetch("/ow/dc/settings/delays?srv=" + props.srv, (res) => {
      setDelays(res);
    });
  }, [props.srv]);

  return (
    <Callout title={<Trans>purge delays</Trans>}>
      {Object.keys(delays).map((delay) => (
        <FormGroup key={props.srv+"*"+delay} label={delay} labelFor={delay} inline={true}>
          <NumericInput
            id={delay}
            defaultValue={delays[delay]?.value || 1}
            min={1}
            max={999}
            maxLength={3}
            onValueChange={(value) => {
              const body = {};
              body[delay] = value;
              authenticatedPostFetch("/ow/dc/settings/delays?srv=" + props.srv, body);
            }}
          />
        </FormGroup>
      ))}
    </Callout>
  );
}
